import {
  confirmDialog,
  CustomCollapseCard,
  successDialog,
  Text,
  useText,
} from '@src/components';
import React, { useCallback, useState } from 'react';
import '@src/styles/manageMyCards/blockedCardList.scss';
import { useDispatch, useSelector } from 'react-redux';
import BlockedModal from './BlockedModal';
import { cancelRequestsDelete, cardGetPagedList, setSelectedCards } from '@src/store/slice/manageMyCardsSlice';
import {VirtualizedAndLazyScrollTable} from "@src/components/VirtualizedAndLazyScrollTable";
import { handleAuthStatus } from '@src/utils/utils';
import CardFilter from './CardFilter';
import { blockedCardTypeEnum, blockedTypeList } from '@src/store/enums';
const BlockedCardList = () => {
  const dispatch = useDispatch();
  const { list, filterObject } = useSelector((state) => state?.manageMyCards);
  const [blockedModalVisible, setBlockedModalVisible] = useState(false);
  const confirmDialogMessage = useText('giveUpCancellationText');
  const cardList = useText('cardList');
  const { userAuthorizationStatus } = useSelector((state) => state?.user);

  const cardNumber = useText('cardNumber4');
  const name = useText('nameUpperCase');
  const surname = useText('surnameUpperCase');
  const referenceCode = useText('referenceCode3');
  const phoneNumber = useText('phoneNumberUpperCase');
  const actionUpperCase = useText('actionUpperCase');

  const handleTableChange = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(cardGetPagedList({ body: {}, ...filterObject, pageNumber, pageSize }));
    },
    [dispatch, filterObject],
  );

  const cancelCancellation = useCallback(
    async (record) => {
      confirmDialog({
        title: <Text t="attention" />,
        message: confirmDialogMessage,
        onOk: async () => {
          const action = await dispatch(cancelRequestsDelete({ cswId: record?.cswId }));

          if (cancelRequestsDelete.fulfilled.match(action)) {
            successDialog({
              title: <Text t="success" />,
              message: action?.payload?.message || blockedTypeList[3].text,
              onOk: async () => {
                await dispatch(cardGetPagedList({ ...filterObject }));
              },
              onCancel: () => {},
            });
          }
        },
      });
    },
    [dispatch, filterObject],
  );

  const handleBlockProceed = useCallback(
    async (record) => {
      dispatch(setSelectedCards([record]));
      setBlockedModalVisible(true);
    },
    [dispatch],
  );

  const columns = [
    {
      title:  cardNumber,
      dataIndex: 'cardNumber',
      key: 'cardNumber',
      width: 162.7,
    },
    {
      title: name,
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: surname,
      dataIndex: 'surname',
      key: 'surname',
      width: 150,
    },
    {
      title: referenceCode,
      dataIndex: 'refNo',
      key: 'refNo',
      width: 135,
      align: 'left',
    },
    {
      title: phoneNumber,
      dataIndex: 'gsm',
      key: 'gsm',
      width: 130,
    },
  ];
  !handleAuthStatus(userAuthorizationStatus, 'ManageMyCardsCancelCancellation') &&
  columns.push({
    title: actionUpperCase,
    dataIndex: 'action',
    key: 'action',
    width: 150,
    align: 'center',
    render: (_, record) => {
      const cswId = record?.cswId; 
      const cswState = blockedCardTypeEnum.find(card => card.value === record?.cswState)?.value;
      if(cswId && cswState !== undefined){
        return (
          <span><Text t="requestProcessed" /></span>
        );   
      } else if(cswId){
        return (
          <span className="recanceled-btn" onClick={() => cancelCancellation(record)}>
           <Text t="blockedGiveup" />
        </span>  
        );   
      } else{
        return (
          <span id="ticketRestaurant-manageMyCards-blockedCardList-blocked-btn" className="recanceled-btn" onClick={() => handleBlockProceed(record)}>
            <Text t="blockedProgress" />
          </span>
        );
      }
    },
  });

  return (
    <CustomCollapseCard cardTitle={cardList} className="blocked-card-list-card">
      <CardFilter/>
      <VirtualizedAndLazyScrollTable
        pagination={false}
        dataSource={list}
        columnsData={columns}
        rowKey={(record) => `manage-my-card-${record?.id}`}
        getDataFunc={async (_, pageSize) => {
          await handleTableChange(1, pageSize);
        }}
      />

      <BlockedModal
        modalVisible={blockedModalVisible}
        handleModalVisible={setBlockedModalVisible}
      />
    </CustomCollapseCard>
  );
};

export default BlockedCardList;
